module.exports = __webpack_public_path__ + "static/media/Saúde-Mental-Maternal.e240650e.jpg";